import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import RestoreModal from 'widgets/restore/restoreModal';
import React, { useContext, useState } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import ErrorModal from 'shared/lib/components/modals/errorModal';
import { trashApi } from 'entities/trash/api/trashApi';

export type RestoreFolderAfterReactions = {
  afterFolderRestore?: (folder: { id: string; name: string }) => void;
};

export default observer(function RestoreFolderModalController({
  folder,
  afterFolderRestore,
  handleClose,
}: {
  folder: { id: string; name: string };
  handleClose: () => void;
} & RestoreFolderAfterReactions) {
  const { t } = useTranslation();
  const { mobxStore } = useContext(MobxContext);

  const [dublicateName, setDublicateName] = useState<null | string>(null);

  return (
    <>
      <RestoreModal
        isOpen={true}
        handleClose={handleClose}
        initialSectionId={null}
        initialFolderId={null}
        headerText={t('actions.restoring.folder')}
        applyText={t('common.restore')}
        onSubmit={async (params) => {
          try {
            await trashApi.restoreFolder(folder.id, params);
            afterFolderRestore && afterFolderRestore(folder);
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;
            console.error(e);

            if (
              err?.response?.status === 400 &&
              err?.response?.data?.detail === BackErrors.FolderExists
            ) {
              setDublicateName(folder.name || '');
              return;
            }

            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }
          handleClose();
        }}
      ></RestoreModal>

      {dublicateName && (
        <ErrorModal
          mainText="Ошибка действия"
          isOpen={true}
          onClose={() => setDublicateName(null)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Невозможно восстановить папку, так как папка с&nbsp;именем &laquo;
            <span style={{ fontWeight: 700 }}>{dublicateName}</span>&raquo; уже
            существует в&nbsp;указанном разделе
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
